exports.bleNusServiceUUID = "6e400001-b5a3-f393-e0a9-e50e24dcca9e";
exports.bleNusCharRXUUID = "6e400002-b5a3-f393-e0a9-e50e24dcca9e";
exports.bleNusCharTXUUID = "6e400003-b5a3-f393-e0a9-e50e24dcca9e";
exports.MTU = 20;
